import {Injectable} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import 'rxjs/add/operator/filter';

@Injectable()
export class HistoryService {

  previousRoute: string;
  currentRoute: string;

  constructor(private router: Router) {
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe(e => {
        this.previousRoute = this.currentRoute;
        this.currentRoute = (<any>e).url;
      });
  }

  back(scrollTop = true) {
    const route = this.previousRoute;
    this.router.navigateByUrl(route)
      .then(() => {
        if (scrollTop) {
          window.scrollTo(0, 0)
        }
      })
  }
}
